import PropTypes from 'prop-types';
import { promotionTypeOptions } from 'constants/promotions';

export const PROMOTION_PROPTYPES = PropTypes.shape({
  id: PropTypes.number,
  promotion_type: PropTypes.oneOf(promotionTypeOptions)
});
